import { render, staticRenderFns } from "./UserAjustes.vue?vue&type=template&id=906d16b0&scoped=true&"
import script from "./UserAjustes.vue?vue&type=script&lang=js&"
export * from "./UserAjustes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "906d16b0",
  null
  
)

export default component.exports